export const Y_FIELD = '$$yField$$';
export const DIFF_FIELD = '$$diffField$$';
export const ABSOLUTE_FIELD = '$$absoluteField$$';
export const IS_TOTAL = '$$isTotal$$';
